import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppState } from "redux/store";
import CmsUpdateHeader from "./cmsUpdateHeader";
import CmsUpdate from "./cmsUpdate";
import { getCmsDetail } from "redux/actions";

const CmsUpdateIndex: React.FC = () => {
  const dispatch = useDispatch();

  const { pageID } = useParams<{ pageID?: string }>(); 
console.log(pageID);
  

  const { currentCms } = useSelector<AppState, AppState["cmsMaster"]>(
    ({ cmsMaster }) => cmsMaster
  );

  useEffect(() => {
    dispatch({ type: "RESET_CMS_DATA" });
    if (pageID !== undefined) {
      dispatch(getCmsDetail(pageID));
    }
  }, [dispatch, pageID]);

  return (
    <>
      {currentCms ? (
        <AppAnimate animation="transition.slideUpIn" delay={200}>
          <AppCard>
            <CmsUpdateHeader cms={currentCms} />
           
            <AppGridContainer>
              <CmsUpdate Cms={currentCms} /> 
            </AppGridContainer>
          </AppCard>
        </AppAnimate>
      ) : null}
      <AppInfoView />
    </>
  );
};

export default CmsUpdateIndex;
